
import { useLocation } from "react-router-dom";
import { RiderLayout } from "@/components/rider/RiderLayout";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, MessageSquare } from "lucide-react";
import { motion } from "framer-motion";
import { useEffect } from "react";

const RiderTripThankYou = () => {
  const location = useLocation();
  const { phoneNumber, customerName } = location.state || {};

  // Scroll to top on mobile when component mounts
  useEffect(() => {
    if (window.innerWidth < 768) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, []);

  return (
    <RiderLayout>
      <div className="container mx-auto px-4 py-12 max-w-2xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div className="mb-8">
            <CheckCircle className="h-20 w-20 text-green-500 mx-auto mb-4" />
            <h1 className="text-4xl font-bold text-black mb-4">Thank You!</h1>
            <p className="text-xl text-gray-600">
              Your trip request has been submitted successfully.
            </p>
          </div>

          <Card className="shadow-xl border-0 bg-white">
            <CardContent className="p-8">
              <div className="flex items-center justify-center mb-6">
                <MessageSquare className="h-12 w-12 text-blue-500 mr-4" />
                <div className="text-left">
                  <h2 className="text-2xl font-semibold text-black mb-2">
                    Check Your Phone
                  </h2>
                  <p className="text-gray-600">
                    Please check your phone for a message to complete the purchase.
                  </p>
                </div>
              </div>

              {phoneNumber && (
                <div className="bg-gray-50 rounded-xl p-6 mb-6">
                  <p className="text-sm text-gray-600 mb-2">Message sent to:</p>
                  <p className="text-lg font-semibold text-black">{phoneNumber}</p>
                  {customerName && (
                    <>
                      <p className="text-sm text-gray-600 mt-4 mb-2">Customer:</p>
                      <p className="text-lg font-semibold text-black">{customerName}</p>
                    </>
                  )}
                </div>
              )}

              <div className="space-y-4 text-left">
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-4 mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">
                    You will receive a text message with a secure payment link within the next few minutes.
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-4 mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">
                    Complete your payment through the link to confirm your party bus reservation.
                  </p>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-4 mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700">
                    Once payment is complete, you'll receive confirmation details and your driver's contact information.
                  </p>
                </div>
              </div>

              <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
                <p className="text-sm text-yellow-800">
                  <strong>Didn't receive a message?</strong> Check your spam folder or contact our support team.
                </p>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </RiderLayout>
  );
};

export default RiderTripThankYou;
